// assets/eos-marquee.js
import { Component } from '@theme/component';

/**
 * @typedef {object} EosMarqueeRefs
 * @property {HTMLButtonElement} toggle - The pause / play control.
 */

const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

/**
 * Pause control for the marquee band.
 *
 * The motion itself is pure CSS; this element only owns the one thing CSS
 * cannot do — remember that the visitor asked it to stop (WCAG 2.2.2). It
 * starts paused for visitors who prefer reduced motion and lets them opt in.
 *
 * @extends Component<EosMarqueeRefs>
 */
class EosMarquee extends Component {
  requiredRefs = ['toggle'];

  connectedCallback() {
    super.connectedCallback();
    this.#setPaused(window.matchMedia(REDUCED_MOTION).matches);
  }

  toggle() {
    this.#setPaused(this.dataset.paused !== 'true');
  }

  /** @param {boolean} paused */
  #setPaused(paused) {
    this.dataset.paused = String(paused);

    const { toggle } = this.refs;
    toggle.setAttribute('aria-pressed', String(paused));
    toggle.setAttribute('aria-label', paused ? toggle.dataset.labelPlay || '' : toggle.dataset.labelPause || '');
  }
}

/*
  "-component" soneki şart: assets/component.js yükseltme yarışı kurtarmasını
  yalnızca bu sonekle biten etiketlerde çalıştırır. Sonek olmadan, modül
  yüklenmeden önceki tıklama sessizce kaybolur.
*/
if (!customElements.get('eos-marquee-component')) {
  customElements.define('eos-marquee-component', EosMarquee);
}
